import { styled } from '@linaria/react';

import Demo, {
  DemoToggleButtonGroupControl,
} from '@/components/Demo';
import Paper from '@/components/Paper';
import CodeSnippetProvider from '@/components/CodeSnippet/CodeSnippetProvider';

import { CODE_BACKGROUND } from './index.constants';
import {
  INITIAL_VALUE,
  constructSnippet,
} from './GridVsFlexbox.helpers';
import LayoutElement from './LayoutElement';

function GridVsFlexbox({ codeOutput }) {
  return (
    <Demo
      initialValues={{
        layoutMode: INITIAL_VALUE,
      }}
      controlPosition="top"
      customGrid={{ gridTemplateColumns: '1fr' }}
      outputWrapper={null}
      controls={[
        <DemoToggleButtonGroupControl
          key="layoutMode"
          id="layoutMode"
          label="Layout Algorithm"
          options={['flexbox', 'grid']}
        />,
      ]}
    >
      {({ layoutMode }) => {
        return (
          <Row>
            <CodeColumn>
              <CodeSnippetProvider
                lang="css"
                code={constructSnippet(layoutMode)}
              >
                {codeOutput}
              </CodeSnippetProvider>
            </CodeColumn>
            <DemoColumn>
              <Container
                style={{
                  display: layoutMode === 'grid' ? 'grid' : 'flex',
                  justifyContent: 'center',
                  alignContent:
                    layoutMode === 'grid' ? 'center' : undefined,
                  alignItems:
                    layoutMode === 'flexbox' ? 'center' : undefined,
                }}
              >
                <ChildElement>.element</ChildElement>
              </Container>
            </DemoColumn>
          </Row>
        );
      }}
    </Demo>
  );
}

const Row = styled.div`
  display: flex;
  gap: 24px;
  padding-bottom: 16px;

  @media (max-width: 34rem) {
    flex-direction: column-reverse;
    align-items: center;
  }
`;
const Column = styled.div`
  position: relative;
  background: ${CODE_BACKGROUND};
  border-radius: 8px;
  width: 100%;

  @media (max-width: 34rem) {
    flex: 1;
  }
`;

const CodeColumn = styled(Column)`
  min-width: 300px;
`;

const DemoColumn = styled(Column)`
  display: flex;
  justify-content: center;
  align-self: start;

  @media (max-width: 34rem) {
    align-self: center;
    flex: 1.2;
  }
`;

const Container = styled(Paper)`
  position: relative;
  width: 100%;
  padding: 16px 0px;
  height: 312px;

  @media (max-width: 34rem) {
    height: 200px;
  }
`;

const ChildElement = styled(LayoutElement)`
  width: 50%;
  height: 50%;
`;

export default GridVsFlexbox;
